export default "__VITE_ASSET__2c4494b7__"